import axios from "axios";
import { authHeader } from "./utils";
import { GET_GATEWAY, LIST_GATEWAY } from "./types";

export const getGateway = (id) => async (dispatch) => {
  const res = await axios.get(`/api/gateways/${id}`, {
    headers: authHeader(),
  });
  console.log("res", res.data);
  dispatch({ type: GET_GATEWAY, payload: res.data });
};

export const fetchGateways =
  ({ page, limit, all }) =>
  async (dispatch) => {
    const res = await axios.get("/api/gateways", {
      headers: authHeader(),
      params: { page, limit, all },
    });
    console.log("res", res.data);
    dispatch({ type: LIST_GATEWAY, payload: res.data });
  };

export const submitGateway =
  ({ gateway }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.post("/api/gateways", gateway, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const updateGateway =
  ({ gateway, id }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.put(`/api/gateways/${id}`, gateway, {
          headers: authHeader(),
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });

export const deleteGateway =
  ({ id }) =>
  () =>
    new Promise(async (resolve, reject) => {
      try {
        await axios.delete(`/api/gateways/${id}`, {
          headers: authHeader(),
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
